export default __webpack_public_path__ + "static/media/salami-kawalek.ddce7b75.png";